import React, { FC, HTMLAttributes, Dispatch, SetStateAction } from 'react';
import * as S from './Header.style';
import { AnimatedLogo } from '../AnimatedLogo';
import { ThemeSwitchButton } from '../ThemeSwitchButton';
import { MarketSoundButton } from '../MarketSound';
import { AccountButton } from '../AccountButton';
import { AboutButton } from '../AboutButton';
import { ThemeInterface } from '../../interfaces/themeInterface';

interface HeaderProps extends HTMLAttributes<HTMLDivElement> {
  updateTheme: Dispatch<SetStateAction<ThemeInterface>>;
}

export const Header: FC<HeaderProps> = ({ updateTheme }) => {
  return (
    <S.HeaderWrapper>
      <AnimatedLogo />
      <S.Controls>
        <AboutButton />
        <AccountButton />
        <MarketSoundButton />
        <ThemeSwitchButton updateTheme={updateTheme} />
      </S.Controls>
    </S.HeaderWrapper>
  );
};
